import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  InputLabel,
  FormControl,
} from '@material-ui/core'

import VariantInput from '../../controls/input/VariantInput'

class CommandParamsDialog extends React.Component {
  static propTypes = {
    command: PropTypes.object.isRequired,
    onExecute: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  }

  static styles = () => ({
  })

  state = { ...this.props.command }

  onExecute = () => {
    this.props.onExecute(this.state)
    this.props.onClose()
  }

  onClose = () => {
    this.props.onClose()
  }

  onParamChange = (name, p) => {
    this.setState(
      (prevState) => ({
        params: {
          ...prevState.params,
          [name]: p,
        },
      }),
    )
  }

  renderParam = ([name, value]) => (
    <div key={name}>
      <FormControl>
        <InputLabel shrink>{name}</InputLabel>
        <VariantInput label={name} value={value} name={name} onChange={(p) => this.onParamChange(name, p)} />
      </FormControl>
    </div>
  )

  render() {
    const { command, params } = this.state

    return (
      <Dialog open onClose={this.onClose}>
        <DialogTitle>Execute “{command}” with</DialogTitle>
        <DialogContent>
          {Object.entries(params).map(this.renderParam)}
        </DialogContent>

        <DialogActions>
          <Button onClick={this.onClose} color="primary">
            Cancel
          </Button>
          <Button onClick={this.onExecute} color="primary">
            Execute
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default withStyles(CommandParamsDialog.styles)(CommandParamsDialog)
